// Debug flag to force logging
const DEBUG = true;

// Immediately log that the module is loaded
console.debug('🚀 [ENV] Module loaded');

declare global {
  interface Window {
    ENV: {
      IS_DEV: boolean;
    };
  }
}

/**
 * Check if we're in development mode
 */
export const isDev = (): boolean => {
  // Use the IS_DEV environment variable from wrangler.toml
  const isDevEnv = window.ENV?.IS_DEV ?? false;
  console.debug('🔍 [ENV] isDev check:', { isDevEnv });
  return isDevEnv;
};

/**
 * Get the base URL for API requests based on the current environment
 */
export const getBaseUrl = (): string => {
  // In development, use the current origin
  if (isDev()) {
    console.debug('🌐 [ENV] Using current origin as base URL:', window.location.origin);
    return window.location.origin;
  }
  
  // In production, use the production URL
  console.debug('🌐 [ENV] Using production base URL: https://www.twsrt.cc');
  return 'https://www.twsrt.cc';
}; 